import React, { useState } from 'react';

type FeatureFlagConfig = {
  testEnvironment: boolean;
  excludeSupplementalFee: boolean;
  feedbackUI: boolean;
  onDemandOnboardingSkipsBankAccountStep: boolean;
  factoring: boolean;
  onboardingPreview: boolean;
  flowOfFundsProgramSetup: boolean;
  detailDrawers: boolean;
  invoiceAdjustments: boolean;
  adjustmentsTab: boolean;
  emailUnsubscribePage: boolean;
  invoiceQuarantines: boolean;
};

const defaultFeatureFlags: FeatureFlagConfig = {
  testEnvironment: true,
  excludeSupplementalFee: false,
  feedbackUI: false,
  onDemandOnboardingSkipsBankAccountStep: false,
  factoring: false,
  onboardingPreview: false,
  flowOfFundsProgramSetup: false,
  detailDrawers: false,
  invoiceAdjustments: false,
  adjustmentsTab: false,
  emailUnsubscribePage: false,
  invoiceQuarantines: false,
};

export const FeatureFlagsContext = React.createContext(defaultFeatureFlags);

type FeatureFlagsProviderProps = {
  children: React.ReactNode;
};

export function FeatureFlagsProvider({ children }: FeatureFlagsProviderProps) {
  const [features] = useState<FeatureFlagConfig>(() => CONFIG.featureFlags);

  return (
    <FeatureFlagsContext.Provider value={features}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

export const useFeatureFlags = () => React.useContext(FeatureFlagsContext);
